import React, { useEffect, useState } from "react";
import arrowCursor from "../assets/cursor-arrow.svg";

const MsFlag = ({ size = 14 }) => (
  <div className="grid grid-cols-2 gap-[1px]" style={{ width: size, height: size }} aria-hidden="true">
    <span className="bg-[#f25022]" />
    <span className="bg-[#7fba00]" />
    <span className="bg-[#00a4ef]" />
    <span className="bg-[#ffb900]" />
  </div>
);

const Clock = () => {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), 1000 * 15);
    return () => window.clearInterval(id);
  }, []);
  const time = now.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  return <span>{time}</span>;
};

const Taskbar = ({ menuItems, windows, onOpen, onRestoreOrToggle, soundOn, onToggleSound, onShutDown }) => {
  const [startOpen, setStartOpen] = useState(false);

  return (
    <div className="fixed inset-x-0 bottom-0 z-[999] flex h-11 items-stretch gap-1.5 px-1.5 win-raised">
      <div className="relative flex items-stretch">
        <button
          type="button"
          onClick={() => setStartOpen((v) => !v)}
          className={`win-btn win-focus-dotted my-1 flex items-center gap-1.5 px-2 text-sm font-bold ${
            startOpen ? "win-btn-pressed" : ""
          }`}
        >
          <MsFlag size={16} />
          Start
        </button>

        {startOpen && (
          <>
            <button
              aria-label="Close start menu"
              className="fixed inset-0 z-[998] cursor-default"
              style={{ cursor: `url(${arrowCursor}) 3 2, auto` }}
              onClick={() => setStartOpen(false)}
            />
            <div className="win-raised absolute bottom-[46px] left-0 z-[999] flex w-72 p-[3px]">
              <div className="win-titlebar-active flex w-8 items-end justify-center pb-3">
                <span
                  className="whitespace-nowrap text-sm font-bold tracking-widest text-cyan-100"
                  style={{ writingMode: "vertical-rl", transform: "rotate(180deg)" }}
                >
                  JAKOB EVENSEN 98
                </span>
              </div>
              <ul className="flex-1 bg-[#c0c0c0] py-1">
                {menuItems.map((item) => (
                  <li key={item.id}>
                    <button
                      type="button"
                      className="win-focus-dotted flex w-full items-center gap-3 px-3 py-1.5 text-left text-sm hover:bg-win-navy hover:text-white"
                      onClick={() => {
                        onOpen(item.id);
                        setStartOpen(false);
                      }}
                    >
                      <span className="text-base" aria-hidden="true">{item.icon}</span>
                      {item.label}
                    </button>
                  </li>
                ))}
                <li className="my-1 border-t border-[#808080]" />
                <li>
                  <button
                    type="button"
                    className="win-focus-dotted flex w-full items-center gap-3 px-3 py-1.5 text-left text-sm hover:bg-win-navy hover:text-white"
                    onClick={() => {
                      setStartOpen(false);
                      onShutDown();
                    }}
                  >
                    <span className="text-base" aria-hidden="true">⏻</span>
                    Shut Down...
                  </button>
                </li>
              </ul>
            </div>
          </>
        )}
      </div>

      <div className="win-sunken-thin my-1 w-2 shrink-0" />

      <div className="my-1 flex min-w-0 flex-1 items-stretch gap-1 overflow-x-auto">
        {windows.map((w) => (
          <button
            key={w.id}
            type="button"
            onClick={() => onRestoreOrToggle(w.id)}
            className={`win-btn win-focus-dotted flex min-w-[120px] max-w-[180px] items-center gap-1.5 truncate px-2 text-xs ${
              !w.minimized ? "win-btn-pressed" : ""
            }`}
            title={w.title}
          >
            <span aria-hidden="true">{w.icon}</span>
            <span className="truncate">{w.title}</span>
          </button>
        ))}
      </div>

      <div className="win-sunken-thin my-1 flex items-center gap-2 px-2 text-xs">
        <button
          type="button"
          aria-label={soundOn ? "Mute sound effects" : "Enable sound effects"}
          onClick={onToggleSound}
          className="win-focus-dotted"
        >
          {soundOn ? "🔊" : "🔇"}
        </button>
        <Clock />
      </div>
    </div>
  );
};

export default Taskbar;
